import { render } from "./PoolIcon.vue?vue&type=template&id=795fd024"
import script from "./PoolIcon.vue?vue&type=script&lang=js"
export * from "./PoolIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__